export default __webpack_public_path__ + "static/media/Connecticut1.46cf7090.png";